<template>
  <i
    v-tooltip.top="text"
    class="far fa-circle-question spm-help-icon"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SpmHelpIcon',

  props: {
    /**
     * Help text shown in the tooltip
     */
    text: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.spm-help-icon {
  margin-left: 0.25rem;
  cursor: help;
}
</style>
